import MyYuukke from "../../api/MyYuukke";
import ProfileService from "../../api/ProfileService";
import {
  CALENDAR_SERVICE_LIST,
  CATEGORY_V2_LIST,
  DELETE_PAGE,
  EVENT_LIST,
  EVENT_LOADER,
  EVENT_VIDEO_LIST,
  GET_SERVICE_DASHBOARD,
  GET_SUBSCRIPTION_LIST,
  GET_USER_SERVICE,
  GET_USER_SERVICE_RESOURCE,
  GET_USER_SLOTS,
  MODIFY_SUBSCRIPTION_STATUS,
  SAVE_PAGES,
  SPECIALIZATION_V2_LIST,
  USER_SUBSCRIPTION_STATUS,
  GET_SERVICE_DASHBOARD_PASSBOOK,
  FETCH_EXPERT_BOOKINGS_REQUEST,
  FETCH_EXPERT_BOOKINGS_SUCCESS,
  FETCH_EXPERT_BOOKINGS_FAILURE,
  FETCH_EXPERT_BOOKINGS_COUNT,
  CLAIM_REFERRAL_REWARD_REQUEST,
  CLAIM_REFERRAL_REWARD_SUCCESS,
  CLAIM_REFERRAL_REWARD_FAILURE,
} from "../types";

export const getEventDetails = (data) => async (dispatch) => {
  dispatch({
    type: EVENT_LOADER,
    payload: true,
  });
  MyYuukke.getEventList(data)
    .then((response) => {
      dispatch({
        type: EVENT_LIST,
        payload: response.data.data,
        page: data.page,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};
export const getEventVideos = (data) => async (dispatch) => {
  dispatch({
    type: EVENT_LOADER,
    payload: true,
  });
  MyYuukke.getEventVideoList(data)
    .then((response) => {
      dispatch({
        type: EVENT_VIDEO_LIST,
        payload: response.data.data,
        page: data.page,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const getUserSlots = () => async (dispatch) => {
  dispatch({
    type: EVENT_LOADER,
    payload: true,
  });
  MyYuukke.getUserSlots()
    .then((response) => {
      dispatch({
        type: GET_USER_SLOTS,
        payload: response.data.data,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const savePages = (payload) => async (dispatch) => {
  dispatch({
    type: SAVE_PAGES,
    payload,
  });
};

export const deletePage = (payload) => async (dispatch) => {
  dispatch({
    type: DELETE_PAGE,
    payload,
  });
};

export const saveCalenderSlot =
  (eventName, hours, duration, type, eventId) => async (dispatch) => {
    // dispatch({
    //   type: EVENT_LOADER,
    //   payload: true,
    // });
    let data = {
      eventName: eventName,
      weeklyHours: hours,
      meetingActiveDuration: duration,
      type: type,
    };
    if (eventId) {
      data.id = eventId;
    }
    MyYuukke.saveUserSlots(data)
      .then((response) => {
        console.log("response", response);

        // dispatch({
        //   type: SAVE_USER_SLOT,
        //   payload: response.data.data,
        // });
      })
      .catch((e) => {
        console.log("error", e);
      });
  };
export const saveCalenderDateSpecificHours =
  (date, time, calenderId) => async (dispatch) => {
    dispatch({
      type: EVENT_LOADER,
      payload: true,
    });
    let data = {
      dateSlot: date,
      timeSlot: time,
      calendarEventId: calenderId,
    };

    MyYuukke.saveUserDateSlot(data)
      .then((response) => {
        console.log("response", response);
      })
      .catch((e) => {
        console.log("error", e);
      });
  };

export const saveUserSlot = (data) => async (dispatch) => {
  dispatch({
    type: EVENT_LOADER,
    payload: true,
  });

  dispatch({
    type: GET_USER_SLOTS,
    payload: data,
  });
};

export const getSubscriptionList =
  (type = "service") =>
  async (dispatch) => {
    MyYuukke.subscriptionList(type)
      .then((response) => {
        dispatch({
          type: GET_SUBSCRIPTION_LIST,
          payload: response.data.data,
        });
      })
      .catch((e) => {
        console.log("event-list-error", e);
      });
  };

export const getSubscriptionStatus = (type) => async (dispatch) => {
  let data = {
    restrictiontype: type,
  };
  MyYuukke.checkPaymentStatus(data)
    .then((response) => {
      dispatch({
        type: USER_SUBSCRIPTION_STATUS,
        payload: response.data.data,
        subscriptionType: type,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const subscriptionModelStatus = (value) => async (dispatch) => {
  dispatch({
    type: MODIFY_SUBSCRIPTION_STATUS,
    payload: value,
  });
};

export const getCategoryListV2 = () => async (dispatch) => {
  MyYuukke.getCategoryListV2()
    .then((response) => {
      let list = response.data.data.map((item) => {
        return {
          value: item.subCategoryId,
          label: item.subCategoryName,
          pId: item.categoryId,
        };
      });
      dispatch({
        type: CATEGORY_V2_LIST,
        payload: list,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const getCalendarServices = () => async (dispatch) => {
  MyYuukke.getCalendarServices()
    .then((response) => {
      dispatch({
        type: CALENDAR_SERVICE_LIST,
        payload: response.data.data,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const getDirectoryCategoryV1 = () => async (dispatch) => {
  MyYuukke.getDirectoryCategoryV1()
    .then((response) => {

      let category = response.data.data.map((item) => {
        return { value: item.categoryId, label: item.categoryName };
      });
      let obj = {
        category: category,
        subCategory: response.data.data,
      };

      dispatch({
        type: SPECIALIZATION_V2_LIST,
        payload: obj,
      });
    })
    .catch((e) => {
      console.log("event-list-error", e);
    });
};

export const getUserService = (type, value) => async (dispatch) => {
  if (type === "update") {
    dispatch({
      type: GET_USER_SERVICE,
      payload: value,
    });
  } else {
    MyYuukke.getUserService()
      .then((response) => {
        dispatch({
          type: GET_USER_SERVICE,
          payload: response.data.data,
        });
      })
      .catch((e) => {
        console.log("event-list-error", e);
      });
  }
};

// Fix: the original signature was (type, value) which meant calendarId was
// never passed through to MyYuukke.getResourceList(calendarId) — it always
// fetched with `undefined`. calendarId is now the first param, matching how
// Services.jsx calls it: getUserResourceList(calendarId) to fetch, or
// getUserResourceList(calendarId, "update", list) to just push a local update
// into the store without hitting the API again.
// Fix: the original signature was (type, value) which meant calendarId was
// never passed through to MyYuukke.getResourceList(calendarId) — it always
// fetched with `undefined`. calendarId is now the first param, matching how
// Services.jsx calls it: getUserResourceList(calendarId) to fetch, or
// getUserResourceList(calendarId, "update", list) to just push a local update
// into the store without hitting the API again.
export const getUserResourceList = (calendarId, type, value) => async (dispatch) => {
  if (type === "update") {
    dispatch({
      type: GET_USER_SERVICE_RESOURCE,
      payload: value,
    });
  } else {
    MyYuukke.getResourceList(calendarId)
      .then((response) => {
        // Defensive: accept either the {status, data} envelope the rest of
        // the app uses, or a raw array — whichever the backend is currently
        // deployed with. Once the envelope fix is confirmed live, the
        // `?? response.data` fallback can be dropped.
        const payload = response?.data?.data ?? response?.data ?? [];
        dispatch({
          type: GET_USER_SERVICE_RESOURCE,
          payload,
        });
      })
      .catch((e) => {
        console.log("resource-list-error", e);
      });
  }
};

export const getServiceDashBoard = (data) => async (dispatch) => {
  MyYuukke.getServiceDashBoard(data)
    .then((response) => {
      dispatch({
        type: GET_SERVICE_DASHBOARD,
        payload: response.data.data,
      });
    })
    .catch((e) => {
      console.log("GET_SERVICE_DASHBOARD-list-error", e);
    });
};

export const getServiceDashBoardPassBook = (data) => async (dispatch) => {
  MyYuukke.getServiceDashBoardPassBook(data)
    .then((response) => {
      dispatch({
        type: GET_SERVICE_DASHBOARD_PASSBOOK,
        payload: response.data.data,
      });
    })
    .catch((e) => {
      console.log("GET_SERVICE_DASHBOARD_PASSBOOK-list-error", e);
    });
};





export const fetchExpertBookings = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_EXPERT_BOOKINGS_REQUEST });
  try {
    const res = await MyYuukke.getConfirmedExpertBookings(filters);
    const { count = 0, data = [] } = res?.data ?? {};
    dispatch({ type: FETCH_EXPERT_BOOKINGS_SUCCESS, payload: { count, data } });
  } catch (error) {
    dispatch({ type: FETCH_EXPERT_BOOKINGS_FAILURE });
  }
};

export const fetchExpertBookingsCount = () => async (dispatch) => {
  dispatch({ type: FETCH_EXPERT_BOOKINGS_COUNT });

  try {
    const res = await MyYuukke.getConfirmedExpertBookingsCount();

    dispatch({
      type: FETCH_EXPERT_BOOKINGS_COUNT,
      payload: res.data.count || 0,
    });
  } catch (error) {
    dispatch({ type: FETCH_EXPERT_BOOKINGS_FAILURE });
  }
};


// redux/actions/calendarAction.js
export const claimReward = ({ referralIds, rewardType }) => async (dispatch) => {
  dispatch({ type: CLAIM_REFERRAL_REWARD_REQUEST });
  try {
    const res = await ProfileService.ClaimReferral({ referralIds, rewardType });
    dispatch({ type: CLAIM_REFERRAL_REWARD_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to claim referral reward";
    dispatch({ type: CLAIM_REFERRAL_REWARD_FAILURE, payload: message });
    throw new Error(message);
  }
};